import * as React from "react";

const ThumbDriveIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clipPath="url(#clip0_201_2250)">
      <path
        fill="#3B598D"
        d="M12.004 24.009c6.63 0 12.005-5.375 12.005-12.005S18.634 0 12.004 0 0 5.374 0 12.004 5.374 24.01 12.004 24.01"
      ></path>
      <path
        fill="#FEFEFE"
        d="M6.405 18.968a1.356 1.356 0 0 0 1.372-1.372 1.355 1.355 0 0 0-1.372-1.373 1.354 1.354 0 0 0-1.364 1.373 1.355 1.355 0 0 0 1.364 1.372m0-2.288a.907.907 0 0 1 .914.916.906.906 0 0 1-.914.906.906.906 0 0 1-.907-.906.906.906 0 0 1 .907-.916m10.877-6.277 1.88-1.864a.23.23 0 0 0 0-.339l-1.516-1.507-2.033 2.033zm-1.99-2.008 2.04-2.033-1.524-1.525a.23.23 0 0 0-.33 0l-1.873 1.88zm-2.017-1.364a.237.237 0 0 0-.33 0l-.644.636q.09.07.17.152l3.71 3.71q.081.08.152.17l.644-.644a.23.23 0 0 0 0-.322z"
      ></path>
      <path
        fill="#FEFEFE"
        d="M9.937 19.23a1.48 1.48 0 0 0 1.042-.423l4.88-4.888a1.46 1.46 0 0 0 .423-1.034 1.46 1.46 0 0 0-.423-1.033l-3.702-3.72a1.46 1.46 0 0 0-1.034-.423 1.46 1.46 0 0 0-1.042.424l-4.88 4.888a1.46 1.46 0 0 0-.423 1.033c0 .39.144.763.423 1.034l3.703 3.71c.28.272.643.432 1.033.432m-1.55-3.185c.06 0 .118-.025.16-.068l1.593-1.584.297-.017.695-.017 1.1-.042a.23.23 0 0 0 .153-.068l1.068-1.067a.229.229 0 1 0-.322-.322l-1.008 1h-.043l-1.474.059 2.034-2.033a.23.23 0 0 0-.33-.322l-3.135 3.143-.085-1.712v-.05l1-1a.23.23 0 0 0-.005-.326.23.23 0 0 0-.326.004L8.692 12.69a.23.23 0 0 0-.068.17l.06 1.203.05 1.076-.508.516a.229.229 0 0 0 .16.39"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_201_2250">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default ThumbDriveIcon;
